import React, { useState, useEffect } from "react";
import MemberHeader from "@/components/MemberHeader";
import icon_01 from "@/components/Success/images/member-success.png";
import SuccessfullyIcon from "@/assets/memberShip/images/successfully_icon.svg";
import Unsuccessfully_icon from "@/assets/memberShip/images/unsuccessfully.png";
import MemberButton, { MemberAppButtonBox } from "@/components/MemberButton";
import { useWcipNavigate } from "@/hooks";
import { getIsMobile, addViewportMeta } from "@/utils/common";
import { useTranslation } from "react-i18next";
import Unsucc from "@/assets/memberShip/images/unsucc.svg";
import "./style.scss";
import { TrackClickEvent } from "@/utils/adobeLaunch";

// 1, noContacts  2, serviceIssues 3, successful
const NotificationOfMember = ({ pageType = "successful" }) => {
    const isApp = window?.MBSSClient;
    const { t, i18n } = useTranslation();
    const { withLangNavigate } = useWcipNavigate();
    const isEn = i18n.language === "en-us";
    const isMobile = getIsMobile();
    const [btnDelay, setBtnDelay] = useState(false);

    useEffect(() => {
        if (window.location.pathname.includes("forgot")) {
            addViewportMeta(!isEn ? "無法登入" : "Cannot Login");
            // document.title = !isEn ? '無法登入' : "Cannot Login";
            if (pageType === "successful") {
                TrackClickEvent(
                    `btn_wcip-MB_ForgetS5Success_Page`,
                    i18n.language
                );
            }
            if (pageType === "serviceIssues") {
                TrackClickEvent(`btn_wcip-MB_ForgetS5Fail_Page`, i18n.language);
            }
        } else {
            addViewportMeta(!isEn ? "更改密碼" : "Change Password");
            // document.title = !isEn ? '更改密碼' : "Change Password";
            if (pageType === "successful") {
                TrackClickEvent(
                    `btn_wcip-MB_ChangeS4Success_Page`,
                    i18n.language
                );
            }
            if (pageType === "serviceIssues") {
                TrackClickEvent(`btn_wcip-MB_ChangeS4Fail_Page`, i18n.language);
            }
        }
        if (window.MBSSClient) {
            if (
                ["successful", "serviceIssues", "mcSuccess"].includes(pageType)
            ) {
                window.MBSSClient?.hideBackBtn?.();
            }
            if (pageType === "successful") {
                window.MBSSClient?.logout?.();
            }
        }
    }, []);
    const handleToLogin = async () => {
        if (btnDelay) {
            return;
        }
        setBtnDelay(true);
        setTimeout(() => {
            setBtnDelay(false);
        }, 1000);
        const successTrackEvent = () => {
            if (
                window.location.href
                    .toLocaleLowerCase()
                    .includes("change/member")
            ) {
                TrackClickEvent(
                    `btn_wcip-MB_ChangeS4Success_SignIn`,
                    i18n.language
                );
            } else if (
                window.location.href
                    .toLocaleLowerCase()
                    .includes("forgot/member")
            ) {
                TrackClickEvent(
                    `btn_wcip-MB_ForgetS5Success_SignIn`,
                    i18n.language
                );
            }
        };
        if (["successful", "serviceIssues", "mcSuccess"].includes(pageType)) {
            if (window.MBSSClient) {
                if (pageType === "serviceIssues") {
                    window.MBSSClient?.onBackPressed?.();
                } else {
                    setTimeout(() => {
                        window.MBSSClient?.loginTrigger?.();
                    }, 1000);
                    if (pageType === "successful") {
                        successTrackEvent();
                    }
                }
            } else {
                if (pageType === "successful") {
                    successTrackEvent();
                }
                setTimeout(() => {
                    window.location.href = `${
                        window.globalConfig.VITE_MEMBERSHIP_URL
                    }/main/${isEn ? "en-US" : "zh-HK"}/logoutRedirect`;
                }, 1000);
            }
        }
        if (pageType == "noContacts") {
            window.location.href = `tel:%2B852 36903680`;
        }
        if (pageType == "otpMaxFail" || pageType == "locked") {
            if (window.MBSSClient) {
                window.MBSSClient?.onBackPressed?.();
            } else {
                withLangNavigate("/login/member");
            }
        }
    };
    let btnText =
        pageType == "successful"
            ? "MEMBER_CHANGEPASSWORD_SIGIN"
            : pageType == "noContacts"
            ? "MEMBER_UNSUCCESS_NO_CONTACTS_BUTTON"
            : "MEMBER_UNSUCCESS_BUTTON";
    let successLabel = "MEMBER_SUCCESS_UPDATE_TEXT";

    if (pageType == "mcSuccess") {
        btnText = "SUCCESS_BUTTON";
        successLabel = "MEMBER_SUCCESS_MAGICLINK_SEND_TEXT";
    }
    return (
        <div className="notifi-container">
            {!isApp && <MemberHeader></MemberHeader>}
            <div className="flex">
                {["mcSuccess", "successful"].includes(pageType) && (
                    <div className="content">
                        <div
                            className="result-icon successfully"
                            id="result-icon"
                        >
                            <SuccessfullyIcon />
                        </div>
                        <div className="success-update">
                            {t("MEMBER_SUCCESS_UPDATE_TIP")}
                        </div>
                        <div className="success-text">{t(successLabel)}</div>
                        {!isApp && (
                            <MemberButton onClick={handleToLogin}>
                                {t(btnText)}
                            </MemberButton>
                        )}
                    </div>
                )}
                {pageType == "noContacts" && (
                    <div className="content noContacts">
                        <img
                            className="result-icon"
                            id="result-icon"
                            src={Unsuccessfully_icon}
                        />

                        <div className="success-update">
                            {t("MEMBER_UNSUCCESS_NO_CONTACTS")}
                        </div>
                        <div
                            className="success-text"
                            dangerouslySetInnerHTML={{
                                __html: `${t(
                                    "MEMBER_UNSUCCESS_NO_CONTACTS_DESC"
                                )} (${window.errMessageId || "100023"})`,
                            }}
                        ></div>
                        {!isApp && isMobile && (
                            <MemberButton onClick={handleToLogin}>
                                {t("MEMBER_UNSUCCESS_NO_CONTACTS_BUTTON")}
                            </MemberButton>
                        )}
                    </div>
                )}
                {(pageType == "otpMaxFail" || pageType == "locked") && (
                    <div className="content noContacts">
                        <img
                            className="result-icon"
                            id="result-icon"
                            src={Unsuccessfully_icon}
                        />
                        <div className="success-update">
                            {pageType == "otpMaxFail"
                                ? t("MEMBER_UNSUCCESS_NO_CONTACTS")
                                : t("CHANGEPASSWORD_UNSUCCESSFUL")}
                        </div>
                        <div
                            className="success-text"
                            dangerouslySetInnerHTML={{
                                __html:
                                    pageType == "otpMaxFail"
                                        ? t("WCIP_VERIFICATION_UNSUCCESS_TIP")
                                        : t("WCIP_COMMON_ERR021_ERROR", {
                                              code: "ERR021",
                                          }),
                            }}
                        ></div>
                        {!isApp && (
                            <MemberButton onClick={handleToLogin}>
                                {t("MEMBER_UNSUCCESS_BUTTON")}
                            </MemberButton>
                        )}
                    </div>
                )}
                {pageType == "serviceIssues" && (
                    <div className="content">
                        {/* <img
                            className="result-icon"
                            id="result-icon"
                            src={Unsuccessfully_icon}
                        /> */}
                        <div className="result-icon" id="result-icon">
                            <Unsucc></Unsucc>
                        </div>
                        <div className="success-update">
                            {t("MEMBER_UNSUCCESS_TITLE")}
                        </div>
                        <div className="success-text">
                            {t("MEMBER_UNSUCCESS_DESC")}
                        </div>
                        {!isApp && (
                            <MemberButton onClick={handleToLogin}>
                                {t(btnText)}
                            </MemberButton>
                        )}
                    </div>
                )}
            </div>
            {isApp && (
                <MemberAppButtonBox>
                    <MemberButton onClick={handleToLogin}>
                        {t(btnText)}
                    </MemberButton>
                </MemberAppButtonBox>
            )}
        </div>
    );
};

export default NotificationOfMember;
